import { render, staticRenderFns } from "./SourceNotesIcon.vue?vue&type=template&id=1b360469&scoped=true&"
import script from "./SourceNotesIcon.vue?vue&type=script&lang=js&"
export * from "./SourceNotesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b360469",
  null
  
)

export default component.exports